// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScrollButton_scrollButton__kiUAk {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 16rem;
  gap: 10rem;
  background-color: #ffffff;
}
.ScrollButton_scrollButton__kiUAk svg {
  width: 24rem;
  height: 24rem;
}
.ScrollButton_scrollButton__kiUAk svg * {
  stroke: #667085;
}
.ScrollButton_scrollButton__kiUAk:hover {
  background-color: #ffffff;
}
.ScrollButton_scrollButton__kiUAk:hover svg * {
  stroke: black;
}
.ScrollButton_scrollButton__kiUAk:disabled {
  background-color: #eaecf0;
  cursor: not-allowed;
}
.ScrollButton_scrollButton__kiUAk:disabled svg * {
  stroke: #98a2b3;
}`, "",{"version":3,"sources":["webpack://./src/components/ScrollButton/ui/ScrollButton.module.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,cAAA;EACA,UAAA;EAEA,yBCwBM;AD5BR;AAME;EACE,YAAA;EACA,aAAA;AAJJ;AAMI;EACE,eCTK;ADKX;AAQE;EACE,yBCYI;ADlBR;AASM;EACE,aAAA;AAPR;AAYE;EACE,yBC3BO;ED4BP,mBAAA;AAVJ;AAaM;EACE,eC9BG;ADmBX","sourcesContent":["@use \"/src/styles/mixins\" as *;\n@use \"/src/styles/variables\" as *;\n\n.scrollButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 50%;\n  padding: 16rem;\n  gap: 10rem;\n\n  background-color: $white;\n\n  svg {\n    width: 24rem;\n    height: 24rem;\n\n    * {\n      stroke: $gray-500;\n    }\n  }\n\n  &:hover {\n    background-color: $white;\n\n    svg {\n      * {\n        stroke: black;\n      }\n    }\n  }\n\n  &:disabled {\n    background-color: $gray-200;\n    cursor: not-allowed;\n\n    svg {\n      * {\n        stroke: $gray-400;\n      }\n    }\n  }\n}","$font-title: \"Vivl Rail\", sans-serif;\n$font-text: \"Roboto\", sans-serif;\n\n$gray-20: #f9f9fa;\n$gray-25: #fcfcfd;\n$gray-50: #f9fafb;\n$gray-100: #f2f4f7;\n$gray-200: #eaecf0;\n$gray-300: #d0d5dd;\n$gray-400: #98a2b3;\n$gray-500: #667085;\n$gray-600: #475467;\n$gray-700: #344054;\n$gray-800: #1d2939;\n$gray-900: #101828;\n$gray-950: #0C111D;\n\n$main: #47C4F0;\n\n$error-50: #FEF3F2;\n$error-100: #FEE4E2;\n$error-200: #FECDCA;\n$error-300: #FDA29B;\n$error-400: #F97066;\n$error-500: #F04438;\n$error-600: #D92D20;\n\n$green: #17B26A;\n$red: #F04438;\n$orange: #F79009;\n\n$success: $green;\n$error: $red;\n$warning: $orange;\n\n$black: $gray-900;\n$white: #ffffff;\n$text-gray: $gray-500;\n$text-color: #2c2d2e;\n$text-color-secondary: $text-gray;\n$border: $gray-300;\n\n$mobile-width: 700;\n$tablet-width: 1024;\n$laptop-width: 1440;\n$hd: 1680;\n$hd-width: 1920;\n\n$main-container: 1824;\n\n$tr: 0.2s ease-out;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollButton": `ScrollButton_scrollButton__kiUAk`
};
export default ___CSS_LOADER_EXPORT___;
